var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSendNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_310_1294)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.5121,
    height: 21.5121,
    transform: "translate(0.791016 13.0328) rotate(-34.6864)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.365 9.54709L7.09814 12.4283C6.59589 12.5369 6.13529 12.7872 5.77086 13.1495C5.40643 13.5117 5.15344 13.9709 5.04183 14.4725C4.93021 14.974 4.96466 15.4971 5.14109 15.9797C5.31751 16.4624 5.62853 16.8843 6.03732 17.1957L9.6463 19.9848L10.9557 24.3654C11.1007 24.8617 11.3857 25.3057 11.7765 25.6442C12.1674 25.9827 12.6476 26.2013 13.1595 26.2739C13.8186 26.3683 14.4892 26.2149 15.0417 25.8433C15.3325 25.6418 15.5806 25.3848 15.7719 25.0872L23.179 13.6603C23.4662 13.2135 23.6147 12.6916 23.6056 12.1605C23.5965 11.6294 23.4304 11.1129 23.1281 10.6761C22.8258 10.2393 22.4009 9.90184 21.9071 9.70626C21.4132 9.51068 20.8725 9.46575 20.3531 9.57714L20.365 9.54709ZM14.28 24.0813C14.1871 24.2249 14.0551 24.3389 13.8995 24.4099C13.7439 24.4809 13.5712 24.5059 13.4018 24.482C13.2402 24.4563 13.0887 24.3869 12.9637 24.2813C12.8387 24.1756 12.745 24.0378 12.6928 23.8826L11.4683 19.8139L21.5879 12.8103L14.28 24.0813ZM10.4481 18.3398L7.06984 15.8053C6.94307 15.7017 6.84705 15.5655 6.79221 15.4113C6.73737 15.2571 6.7258 15.0908 6.75875 14.9305C6.77776 14.8097 6.82126 14.6941 6.8866 14.5908C6.95193 14.4875 7.03771 14.3986 7.13866 14.3296C7.23759 14.2615 7.34922 14.2139 7.46692 14.1897L20.5677 11.3362L10.4481 18.3398Z",
    fill: "#4F4F4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_310_1294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.5121,
    height: 21.5121,
    fill: "none",
    transform: "translate(0.791016 13.0328) rotate(-34.6864)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendNew);
export default __webpack_public_path__ + "static/media/sendNew.e93d0da1e694df6f1cd97b83f671ca9e.svg";
export { ForwardRef as ReactComponent };